<template>
  <div>
    <van-nav-bar
      title="扫码配货"
      left-text="返回"
      left-arrow
      @click-left="onClickLeft"
      fixed
    />
    <van-tabs class="tabs" v-model="selected" type="line" sticky @click="switchTab">
      <van-tab title="主机"/>
      <van-tab title="配件"/>
    </van-tabs>
    <div class="psiConfirmCont">
      <div v-if="selected == '0'">
        <div class="psiDetailCont">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                @load="onLoad"
                finished-text="没有更多了"
            >
              <div v-for="item in list" class="card" :key="item.uuid" @click="openHostDetail(item.uuid)">
                <template>
                  <table class="layout">
                    <tr>
                      <td><span>整机简介：</span>{{ item.hostIntroduce }}</td>
                      <td width="20%">
                        <div class="hostStatus" v-if="item.status == '0'">
                          未配货
                        </div>
                        <div class="hostStatus" v-if="item.status == '2'">
                          已配货
                        </div>
                      </td>
                    </tr>
                  </table>
                </template>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
      <div v-if="selected == '1'">
        <div class="psiDetailCont">
          <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
            <van-list
                v-model="loading"
                :finished="finished"
                @load="onLoad"
                finished-text="没有更多了"
            >
              <div v-for="item in list" class="card" :key="item.uuid" @click="openMaterialDetail(item.uuid)">
                <template>
                  <table class="layout">
                    <tr>
                      <td><span>商品编码：</span>{{ item.skuCode }}</td>
                    </tr>
                    <tr>
                      <td><span>商品名称：</span>{{ item.skuName }}</td>
                    </tr>
                    <tr>
                      <td><span>应配数量：</span>{{ item.shouldDistributeQuantity }}</td>
                    </tr>
                    <tr>
                      <td><span>已配数量：</span>{{ item.distributedQuantity }}</td>
                    </tr>
                  </table>
                </template>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
      <div class="recordBox">
        <div style="display: flex;justify-content: space-between;align-items: center;">
          <div style="flex: 1;background: #1989fa;display: flex;align-items: center;color:white;height: 30px;padding: 0 10px;border-radius: 2px;font-size: 12px;">
            <span>已配数量:</span>
            {{ quantity }}
          </div>
          <div style="margin-left:5px;display: flex;">
            <van-button v-if="showStartAllocation" style="margin-right: 5px;height:30px;font-size: 12px;width: 100px" type="info" size="large" @click="startInput">开始配货</van-button>
            <van-button v-if="!showStartAllocation && showEndAllocation" style="margin-right: 5px;height:30px;font-size: 12px;width: 100px" type="info" size="large" @click="production">生产</van-button>
            <van-button v-if="showEndAllocation" style="height:30px;font-size: 12px; width: 100px" type="info" size="large" @click="endInput">配货完成</van-button>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import {Tab, Tabs, NavBar, Field, Button, List, PullRefresh, Toast} from "vant";
import electronicAllocationService from "../../service/electronicAllocationService";

export default {
  data() {
    return {
      selected: 0,
      type: "",
      quantity: 0,
      list: [],
      loading: false,
      showStartAllocation: false,
      showEndAllocation: false,
      finished: false,
      pageIndex: 0,
      refreshing: false,
      fields:[],
      dictNames: "",
    };
  },
  mounted: async function() {

  },
  components: {
    [NavBar.name]: NavBar,
    [Field.name]: Field,
    [Button.name]: Button,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Tabs.name]: Tabs,
    [Tab.name]: Tab,
},
  created: async function () {
    let tabIndex = localStorage.getItem('allocationDetailTabIndex');
    if(tabIndex === undefined || tabIndex === null) {
      tabIndex = 0;
      this.selected = 0;
    }else {
      this.selected = parseInt(tabIndex);
    }
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1);
    },
    openHostDetail(id){
      if (this.showStartAllocation){
        Toast.fail("还没开始配货");
        return;
      }
      if (!this.showEndAllocation){
        Toast.fail("已经配货完成");
        return;
      }
      this.$router.push({path:"allocationHostDetail/" + id})
    },
    openMaterialDetail(id){
      if (this.showStartAllocation){
        Toast.fail("还没开始配货");
        return;
      }
      if (!this.showEndAllocation){
        Toast.fail("已经配货完成");
        return;
      }
      this.$router.push({path:"allocationMaterialDetail/" + id })
    },
    async onLoad() {
      this.pageIndex++;
      let tabIndex = localStorage.getItem('allocationDetailTabIndex');
      if (tabIndex == "1"){
        let resp = await electronicAllocationService.getAllocationOfCargoMaterial(
            this.pageIndex,
            this.$route.params.allocationDataId
        );
        if (resp.data.Status == '1' && resp.data.Data.data.length > 0) {
          this.quantity = 0;
          resp.data.Data.data.forEach(item => {
            this.quantity += item.distributedQuantity;
          });
        }
        let resp2 = await electronicAllocationService.getOrderInfoByOrderId(this.$route.params.allocationDataId);
        if (resp2.data.Data[0].status == '1'){
          this.showStartAllocation = false;
          this.showEndAllocation = true;
        }else if (resp2.data.Data[0].status == '2'){
          this.showStartAllocation = false;
          this.showEndAllocation = false;
        }else {
          this.showStartAllocation = true;
          this.showEndAllocation = true;
        }
        this.loading = false;
        this.refreshing = false;
        this.list = [...this.list, ...resp.data.Data.data];
        this.finished = resp.data.Data.total <= this.list.length;
      }else{
        let resp = await electronicAllocationService.getAllocationOfCargoHost(
            this.pageIndex,
            this.$route.params.allocationDataId
        );
        if (resp.data.Status == '1' && resp.data.Data.data.length > 0) {
          this.quantity = 0;
          resp.data.Data.data.forEach(item => {
            if (item.status == '2'){
              this.quantity ++;
            }
          });
        }
        let resp2 = await electronicAllocationService.getOrderInfoByOrderId(
            this.$route.params.allocationDataId);
        if (resp2.data.Data[0].status == '1'){
          this.showStartAllocation = false;
          this.showEndAllocation = true;
        }else if (resp2.data.Data[0].status == '2'){
          this.showStartAllocation = false;
          this.showEndAllocation = false;
        }else {
          this.showStartAllocation = true;
          this.showEndAllocation = true;
        }
        this.loading = false;
        this.refreshing = false;
        this.list = [...this.list, ...resp.data.Data.data];
        this.finished = resp.data.Data.total <= this.list.length;
      }
    },
    async startInput() {
      let resp = await electronicAllocationService.updateStatusByOrderId(this.$route.params.allocationDataId, "1");
      if (resp.data.Status == '1'){
        Toast.success("开始配货");
        this.showStartAllocation = false;
        this.showEndAllocation = true;
      }
    },
    async production() {
      let resp = await electronicAllocationService.examineIsProduction(this.$route.params.allocationDataId);
        if (resp.data.Status === "1") {
          if (resp.data.Data === "Yes") {
            let roducableQuantity = 0;
            let resp1 = await electronicAllocationService.getRoducableQuantity(this.$route.params.allocationDataId);
              if (resp1.data.Status === "1") {
                roducableQuantity = Number(resp.data.Data);
              } else {
                Toast.fail("操作失败");
              }
            if (roducableQuantity !== 0) {
              let resp2 = await electronicAllocationService.createProduction(this.$route.params.allocationDataId);
                  if (resp2.data.Status === "1") {
                    Toast.success("操作成功");
                  } else {
                    Toast.fail("操作失败");
                  }
            } else {
              Toast.fail("当前订单没有可生产数据，请先配货。");
            }
          } else if (resp.data.Data === "No") {
            Toast.fail("当前订单已经完全生产，无法继续生产。");
          }
        } else {
          Toast.fail("操作失败");
        }
    },
    async endInput() {
      let resp = await electronicAllocationService.updateStatusByOrderId(this.$route.params.allocationDataId, "2");
      if (resp.data.Status == '1'){
        Toast.success("配货完成");
      }else {
        this.showStartAllocation = true;
        this.showEndAllocation = true;
      }
    },
    switchTab(tabIndex) {
      localStorage.setItem('allocationDetailTabIndex', tabIndex);
      window.scrollTo(0, 0);
      this.selected = tabIndex;
      this.onRefresh();
    },
    onRefresh() {
      this.finished = false;
      this.loading = true;
      this.pageIndex = 0;
      this.list = [];
      this.onLoad();
    }
  },
};
</script>

<style scoped>
.psiConfirmCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 120px;
  overflow: hidden;
}
.btnBox {
}
.recordBox {
  padding: 0.5rem 0;
  box-sizing: border-box;
  margin-top: 2rem;
  bottom: 0;
  position: fixed;
  width: 100%;
}
.psiDetailCont {
  width: 100%;
  margin: 0 auto;
  margin-top: 20px;
}
.hostStatus {
  background-color: #e2e3e2;
  text-align: center;
}
</style>
